module.exports = __webpack_public_path__ + "assets/img/ic-make-hover.5bc99d18.svg";